/* ==========================================================================
   Sunday Meadow - Theme JavaScript
   Cart drawer, mobile menu, AJAX add-to-cart, FAQ accordion, scroll reveal
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Utility ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  function fetchJSON(url, opts) {
    return fetch(url, {
      ...opts,
      headers: { 'Content-Type': 'application/json', ...opts?.headers },
    }).then(r => r.json());
  }

  /* ---------- Header scroll effect ---------- */
  const header = $('[data-header]');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > 40);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Mobile Menu ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  const menuCloseBtns = $$('[data-menu-close]');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle?.classList.add('is-open');
    menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  menuToggle?.addEventListener('click', function () {
    mobileMenu?.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  menuCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeMenu);
  });

  /* ---------- Cart Drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartToggleBtns = $$('[data-cart-toggle]');
  const cartCloseBtns = $$('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });

  cartCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  /* Close drawer/menu on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMenu();
    }
  });

  /* ---------- AJAX Add to Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          const temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          const newDrawer = temp.querySelector('[data-cart-drawer]');
          if (newDrawer && cartDrawer) {
            cartDrawer.innerHTML = newDrawer.innerHTML;
            // Re-bind close buttons inside drawer
            $$('[data-cart-close]', cartDrawer).forEach(function (btn) {
              btn.addEventListener('click', closeCart);
            });
            // Re-bind line item quantity buttons
            bindLineItemButtons();
          }
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart], [data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"], [data-add-btn]');
    var originalText = btn?.textContent;
    if (btn) {
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="spinner"></span>';
    }

    var formData = new FormData(form);
    var body = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || 1, 10),
    };

    fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify(body) })
      .then(function () {
        return fetchJSON('/cart.js');
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
          }, 1500);
        }
        return refreshCartDrawer();
      })
      .then(function () {
        openCart();
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        }
      });
  });

  /* ---------- Line Item Quantity (Cart Drawer) ---------- */
  function updateLineItem(key, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      return refreshCartDrawer();
    });
  }

  function bindLineItemButtons() {
    $$('[data-line-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-minus');
        var input = $('[data-line-qty="' + key + '"]');
        var qty = Math.max(0, parseInt(input?.value || 1, 10) - 1);
        updateLineItem(key, qty);
      });
    });

    $$('[data-line-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-line-plus');
        var input = $('[data-line-qty="' + key + '"]');
        var qty = parseInt(input?.value || 1, 10) + 1;
        updateLineItem(key, qty);
      });
    });
  }

  bindLineItemButtons();

  /* ---------- Product Page: Quantity Selector ---------- */
  $$('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (input) input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  });

  $$('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      if (input) input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- Product Page: Thumbnail Gallery ---------- */
  $$('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = $('#product-main-img');
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-full-src');
      }
      $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- FAQ Accordion ---------- */
  $$('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq]');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');

      // Close all
      $$('[data-faq]').forEach(function (faq) {
        faq.classList.remove('is-open');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  /* ---------- Scroll Reveal ---------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    $$('.reveal, .reveal-stagger').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show everything
    $$('.reveal, .reveal-stagger').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

})();
